import {
  abrirSesionCaja,
} from "../infraestructure/supabase/cajaSesion.repository.js";

import { obtenerSesionAbiertaPorDiaUseCase } from "./obtenerSesionAbiertaPorDia.usecase.js";
import { mapCajaSesionFromDB } from "../domain/mappers/cajaSesion.mapper.js";

export async function abrirCajaUseCase({
  usuarioId,
  saldoInicial,
  punto,
  fecha,          // 👈 ahora es parte del dominio
  observaciones,
}) {
  // 1️⃣ Validación por punto + fecha
  const sesionExistente = await obtenerSesionAbiertaPorDiaUseCase({
    punto,
    fecha,
  });

  if (sesionExistente) {
    throw new Error(
      "Ya existe una sesión de caja abierta para este punto en esta fecha"
    );
  }

  // 2️⃣ Crear sesión
  const creadaDB = await abrirSesionCaja({
    id_usuario_apertura: usuarioId,
    saldo_inicial: saldoInicial,
    punto,
    fecha_apertura: fecha,
    observaciones,
  });

  // 3️⃣ Devolver entidad de dominio
  return mapCajaSesionFromDB(creadaDB);
}